enum PartnerPermission {
  PARTNERSHIP_OWNER = 'partnership_owner',
  PARTNERSHIP_MEMBER = 'partnership_member',
}
export { PartnerPermission };
